export const MANAGE_LOGIN = 'MANAGE_LOGIN';
export const MANAGE_LOGIN_SUCCESS = 'MANAGE_LOGIN_SUCCESS';
export const MANAGE_LOGIN_FAILURE = 'MANAGE_LOGIN_FAILURE';
export const MANAGE_LOGIN_NEEDS_TEAM = 'MANAGE_LOGIN_NEEDS_TEAM';

export const MANAGE_LOGOUT = 'MANAGE_LOGOUT';

export const MANAGE_FETCH_MEMBERSHIP = 'MANAGE_FETCH_MEMBERSHIP';
export const MANAGE_FETCH_MEMBERSHIP_SUCCESS = 'MANAGE_FETCH_MEMBERSHIP_SUCCESS';
export const MANAGE_FETCH_MEMBERSHIP_FAILURE = 'MANAGE_FETCH_MEMBERSHIP_FAILURE';

export const MANAGE_FETCH_REASONS_SUCCESS = 'MANAGE_FETCH_REASONS_SUCCESS';
export const MANAGE_FETCH_REASONS_FAILURE = 'MANAGE_FETCH_REASONS_FAILURE';

export const MANAGE_CANCEL_MEMBERSHIP = 'MANAGE_CANCEL_MEMBERSHIP';
export const MANAGE_CANCEL_MEMBERSHIP_REQUEST = 'MANAGE_CANCEL_MEMBERSHIP_REQUEST';
export const MANAGE_CANCEL_MEMBERSHIP_SUCCESS = 'MANAGE_CANCEL_MEMBERSHIP_SUCCESS';
export const MANAGE_CANCEL_MEMBERSHIP_FAILURE = 'MANAGE_CANCEL_MEMBERSHIP_FAILURE';

export const MANAGE_CLEAR_ERROR = 'MANAGE_CLEAR_ERROR';

export const MANAGE_REACTIVATE_MEMBERSHIP = 'MANAGE_REACTIVATE_MEMBERSHIP';
export const MANAGE_REACTIVATE_MEMBERSHIP_SUCCESS = 'MANAGE_REACTIVATE_MEMBERSHIP_SUCCESS';
export const MANAGE_REACTIVATE_MEMBERSHIP_FAILURE = 'MANAGE_REACTIVATE_MEMBERSHIP_FAILURE';

export const MANAGE_UPDATE_BILLING = 'MANAGE_UPDATE_BILLING';
export const MANAGE_UPDATE_BILLING_SUCCESS = 'MANAGE_UPDATE_BILLING_SUCCESS';
export const MANAGE_UPDATE_BILLING_FAILURE = 'MANAGE_UPDATE_BILLING_FAILURE';

export const MANAGE_DELETE_ACCOUNT = 'MANAGE_DELETE_ACCOUNT';
export const MANAGE_DELETE_ACCOUNT_SUCCESS = 'MANAGE_DELETE_ACCOUNT_SUCCESS';
export const MANAGE_DELETE_ACCOUNT_FAILURE = 'MANAGE_DELETE_ACCOUNT_FAILURE';

export const MANAGE_FETCH_MEMBERSHIP_OPTIONS_SUCCESS = 'MANAGE_FETCH_MEMBERSHIP_OPTIONS_SUCCESS';
export const MANAGE_FETCH_MEMBERSHIP_OPTIONS_FAILURE = 'MANAGE_FETCH_MEMBERSHIP_OPTIONS_FAILURE';

export const MANAGE_UPGRADE_MEMBERSHIP = 'MANAGE_UPGRADE_MEMBERSHIP';
export const MANAGE_UPGRADE_MEMBERSHIP_SUCCESS = 'MANAGE_UPGRADE_MEMBERSHIP_SUCCESS';
export const MANAGE_UPGRADE_MEMBERSHIP_FAILURE = 'MANAGE_UPGRADE_MEMBERSHIP_FAILURE';

export const MANAGE_VALIDATE_COUPON = 'MANAGE_VALIDATE_COUPON';
export const MANAGE_VALIDATE_COUPON_SUCCESS = 'MANAGE_VALIDATE_COUPON_SUCCESS';
export const MANAGE_VALIDATE_COUPON_FAILURE = 'MANAGE_VALIDATE_COUPON_FAILURE';
export const MANAGE_CLEAR_COUPON = 'MANAGE_CLEAR_COUPON';
export const MANAGE_CLEAR_UPGRADE_RESULT = 'MANAGE_CLEAR_UPGRADE_RESULT';

export function manageLogin(username, password, teamId) {
  return { type: MANAGE_LOGIN, username, password, teamId };
}

export function manageLogout() {
  return { type: MANAGE_LOGOUT };
}

export function manageFetchMembership() {
  return { type: MANAGE_FETCH_MEMBERSHIP };
}

export function manageCancelMembership(membershipId, cancellationReasonId) {
  return { type: MANAGE_CANCEL_MEMBERSHIP, membershipId, cancellationReasonId };
}

export function manageReactivateMembership(membershipId) {
  return { type: MANAGE_REACTIVATE_MEMBERSHIP, membershipId };
}

export function manageUpdateBilling(membershipId, paymentMethodId) {
  return { type: MANAGE_UPDATE_BILLING, membershipId, paymentMethodId };
}

export function manageDeleteAccount() {
  return { type: MANAGE_DELETE_ACCOUNT };
}

export function manageUpgradeMembership(membershipId, productId, enteredCoupon) {
  return { type: MANAGE_UPGRADE_MEMBERSHIP, membershipId, productId, enteredCoupon };
}

export function manageValidateCoupon(enteredCoupon, productId) {
  return { type: MANAGE_VALIDATE_COUPON, enteredCoupon, productId };
}

export function manageClearCoupon() {
  return { type: MANAGE_CLEAR_COUPON };
}

export function manageClearUpgradeResult() {
  return { type: MANAGE_CLEAR_UPGRADE_RESULT };
}

export function manageClearError() {
  return { type: MANAGE_CLEAR_ERROR };
}
